/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    code: "code",
    a: "a",
    pre: "pre",
    h2: "h2"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Importing the CSS"
    }), "\n", _jsxs(_components.p, {
      children: ["To include the packages ", _jsx(_components.code, {
        children: "dnb-ui-core"
      }), ", ", _jsx(_components.code, {
        children: "ui-theme-basis"
      }), " and ", _jsx(_components.code, {
        children: "ui-theme-components"
      }), " in a ", _jsx(_components.a, {
        href: "https://nodejs.org",
        children: "Node.js"
      }), " based environment (given you have a CSS loader in place), do this:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "// This includes the `dnb-ui-core`, `ui-theme-basis` and `ui-theme-components`\nimport '@dnb/eufemia/style'\n"
      })
    }), "\n", _jsx(_components.h2, {
      children: "Gatsby Plugin"
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.a, {
        href: "https://github.com/dnbexperience/gatsby-plugin-eufemia-theme-handler",
        children: "gatsby-plugin-eufemia-theme-handler"
      }), " plugin makes it easy to add the needed styles and provides also a runtime style switch mechanism."]
    }), "\n", _jsx(_components.h2, {
      children: "Importing styles from within CSS"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-css",
        children: "@import url('@dnb/eufemia/style/dnb-ui-core.css');\n@import url('@dnb/eufemia/style/themes/theme-ui/ui-theme-components.css');\n@import url('@dnb/eufemia/style/themes/theme-ui/ui-theme-basis.css');\n"
      })
    }), "\n", _jsx(_components.h2, {
      children: "Legacy import"
    }), "\n", _jsxs(_components.p, {
      children: ["Read more about ", _jsx(_components.a, {
        href: "/uilib/usage/customisation/styling#how-to-deal-with-existing-styles",
        children: "how to deal with existing styles"
      }), "."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "// NB: needs a wrapper class: \".dnb-core-style\"\nimport '@dnb/eufemia/style/basis'\nimport '@dnb/eufemia/style/themes/ui'\n"
      })
    }), "\n", _jsx(_components.h2, {
      children: "Single Component only"
    }), "\n", _jsx(_components.p, {
      children: "It is possible to import a single CSS Style of a single component at once:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "import '@dnb/eufemia/style/core'\nimport '@dnb/eufemia/style/themes/ui'\n\n// Imports only the Button CSS and Main DNB Theme\nimport '@dnb/eufemia/components/button/style'\nimport '@dnb/eufemia/components/button/style/themes/ui'\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
